import { memo } from 'react'

import { Text } from '@cash-me/react-components'

import { Carousel } from 'components/carousel'
import { Grid, Col } from 'components/grid'
import { SectionLabel } from 'components/section-label'
import useWindowSize from 'hooks/useWindowSize'

import { BenefitCard } from './card'
import { benefitCards } from './data'
import * as S from './styles'

const Benefits = memo(() => {
  const { isMobile } = useWindowSize()

  return (
    <S.Benefits>
      <Grid col={{ phone: 1, tablet: 1, desktop: 1 }}>
        <Col>
          <S.Content>
            <S.Header>
              <SectionLabel size="body1" weight="bold" color="white" barColor="#fff">
                Benefícios e Soluções
              </SectionLabel>

              <Text as="h2" size="heading2" weight="medium" color="var(--colors-neutral-text-contrast-default)">
                O crédito que você precisa, do jeito que você merece
              </Text>
            </S.Header>

            {isMobile ? (
              <S.CarouselFull>
                <Carousel
                  navigation={true}
                  swiperOptions={{
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                    slidesOffsetBefore: 48,
                    slidesOffsetAfter: 48
                  }}
                >
                  {benefitCards.map(card => (
                    <BenefitCard key={card.image} {...card} />
                  ))}
                </Carousel>
              </S.CarouselFull>
            ) : (
              <S.CardsGrid>
                {benefitCards.map(card => (
                  <BenefitCard key={card.image} {...card} />
                ))}
              </S.CardsGrid>
            )}
          </S.Content>
        </Col>
      </Grid>
    </S.Benefits>
  )
})

Benefits.displayName = 'Benefits'

export default Benefits
